import { render } from "./App.vue?vue&type=template&id=0890cce4&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-0890cce4"

export default script